import {
  EmptyStateComingSoon,
  EmptyStateContract,
  EmptyStateMission,
  EmptyStateMissionSearch,
  EmptyStatePayslip,
  EmptyStateScheduleMissingPeriods,
  EmptyStateTimeRecord,
  ProfilIcon,
} from 'assets/icons';
import Button from 'components/button';
import { useNavigate } from 'react-router-dom';

const EmptyState = ({ type, children, ...props }) => {
  const navigate = useNavigate();

  const logo = {
    mission_done: (
      <div className={'mx-auto my-2'}>
        <EmptyStateMission wh={256} />
      </div>
    ),
    mission_in_progress: (
      <div className={'mx-auto my-2'}>
        <EmptyStateMission wh={256} />
      </div>
    ),
    mission_soon: (
      <div className={'mx-auto my-2'}>
        <EmptyStateMission wh={256} />
      </div>
    ),
    mission_search: (
      <div className={'mx-auto my-2'}>
        <EmptyStateMissionSearch wh={256} />
      </div>
    ),
    contract: (
      <div className={'mx-auto my-2'}>
        <EmptyStateContract wh={256} />
      </div>
    ),
    time_sheet: (
      <div className={'mx-auto my-2'}>
        <EmptyStateTimeRecord wh={256} />
      </div>
    ),
    payslip: (
      <div className={'mx-auto my-2'}>
        <EmptyStatePayslip wh={256} />
      </div>
    ),
    coming_soon: (
      <div className={'mx-auto my-2'}>
        <EmptyStateComingSoon wh={256} />
      </div>
    ),
    select_mission: (
      <div className={'mx-auto my-2'}>
        <EmptyStateMissionSearch wh={256} />
      </div>
    ),
    schedule_missing_periods: (
      <div className={'mx-auto my-2'}>
        <EmptyStateScheduleMissingPeriods wh={64} />
      </div>
    ),
    identity_validation: (
      <div className={'mx-auto my-2'}>
        <EmptyStateMissionSearch wh={256} />
      </div>
    ),
    qualification: (
      <div className={'mx-auto my-2'}>
        <EmptyStateMissionSearch wh={256} />
      </div>
    ),
    avis_clients: (
      <div className={'mx-auto my-2'}>
        <EmptyStateTimeRecord wh={256} />
      </div>
    ),
    time_sheet_to_be_completed: (
      <div className={'mx-auto my-2'}>
        <EmptyStateTimeRecord wh={256} />
      </div>
    ),
    time_sheet_to_be_checked: (
      <div className={'mx-auto my-2'}>
        <EmptyStateTimeRecord wh={256} />
      </div>
    ),
    time_sheet_litigation: (
      <div className={'mx-auto my-2'}>
        <EmptyStateTimeRecord wh={256} />
      </div>
    ),
    time_sheet_checked: (
      <div className={'mx-auto my-2'}>
        <EmptyStateTimeRecord wh={256} />
      </div>
    ),
    no_profile_assigned: (
      <div className={'flex flex-col items-center justify-center py-16 px-4'}>
        <div className={'w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4'}>
          <ProfilIcon wh={32} color={'#9CA3AF'} />
        </div>
      </div>
    ),
  };

  const title = {
    mission_done: 'Aucune mission terminées',
    mission_in_progress: 'Aucune mission en cours',
    mission_soon: 'Aucune mission prochainement',
    mission_search: 'Pas de missions disponibles',
    contract: 'Aucun contrat signé disponible',
    time_sheet: 'Aucun relevé d’heure à compléter',
    payslip: 'Aucun fiche de paie',
    coming_soon: 'Fonctionnalité bientôt disponible',
    select_mission: 'Sélectionnez une mission',
    log_vivier: 'Aucune notification de vivier',
    schedule_missing_periods: 'Période manquante',
    schedule: 'Nouvelle fonctionnalité Planning',
    mission_invitation: 'Aucun intérimaire à inviter',
    identity_validation: 'Aucun utilisateur à valider',
    qualification: 'Aucune qualification trouvée',
    avis_clients: 'Aucun avis client',
    time_sheet_to_be_completed: 'Aucun relevé non complété',
    time_sheet_to_be_checked: 'Aucun relevé à vérifier',
    time_sheet_litigation: 'Aucun relevé en litige',
    time_sheet_checked: 'Aucun relevé vérifié',
    no_profile_assigned: 'Aucun profil attribué',
  };

  const description = {
    mission_done:
      'Oops, vous n’avez pas encore de missions terminées, pour en avoir il faut postuler à une mission !',
    mission_in_progress:
      'Oops, vous n’avez pas encore de missions en cours, pour en avoir il faut postuler à une mission !',
    mission_soon:
      "Oops, vous n'avez pas encore de missions prochainement, pour en avoir, il faut postuler à une mission !",
    mission_search:
      'Oops, il n’y a pas encore de missions disponibles pour le moment, un peu de patience',
    contract:
      'Oops, il n’y a pas encore de missions disponibles pour le moment, un peu de patience',
    time_sheet:
      'Oops, il n’y a pas encore de missions disponibles pour le moment, un peu de patience',
    payslip:
      'Oops, il n’y a pas encore de missions disponibles pour le moment, un peu de patience',
    coming_soon:
      'Vous serez notifié une fois que cette fonctionnalité sera disponible.',
    select_mission: 'Sélectionnez une mission pour exécuter une action.',
    log_vivier:
      'Oops, il n’y a pas encore de notification de viviers pour le moment.',
    schedule_missing_periods:
      'Ajoutez une date de début et de fin pour pouvoir éditer le planning de la mission',
    schedule:
      "Activez la fonctionnalité planning pour un suivi clair et efficace de vos missions d'intérim.",
    mission_invitation: "Pas d'intérimaire à inviter pour le moment",
    identity_validation: "Il n'y a pas encore d'utilisateurs en attente de validation d'identité.",
    qualification: "Il n'y a pas encore de qualifications disponibles. Créez-en une pour commencer.",
    avis_clients: "Il n'y a pas encore d'avis clients à traiter pour le moment.",
    time_sheet_to_be_completed: "Aucun relevé d'heures n'est en attente de complétion par l'intérimaire pour cette période.",
    time_sheet_to_be_checked: "Aucun relevé d'heures n'est en attente de vérification pour cette période.",
    time_sheet_litigation: "Aucun relevé d'heures n'est en litige pour cette période.",
    time_sheet_checked: "Aucun relevé d'heures n'a été vérifié pour cette période.",
    no_profile_assigned: "Vous devez attribuer un profil à cette mission.",
  };

  const button = {
    mission_done: (
      <div className={'my-3'}>
        <Button
          color={'PRIMARY'}
          size={'LG'}
          onClick={(e) => navigate('/searchMission')}
        >
          Rechercher de missions
        </Button>
      </div>
    ),
    mission_in_progress: (
      <div className={'my-3'}>
        <Button
          color={'PRIMARY'}
          size={'LG'}
          onClick={(e) => navigate('/searchMission')}
        >
          Rechercher de missions
        </Button>
      </div>
    ),
    mission_soon: (
      <div className={'my-3'}>
        <Button
          color={'PRIMARY'}
          size={'LG'}
          onClick={(e) => navigate('/searchMission')}
        >
          Rechercher de missions
        </Button>
      </div>
    ),
    contract: '',
    time_sheet: '',
    payslip: '',
    coming_soon: '',
  };

  // Rendu spécial pour no_profile_assigned avec style personnalisé
  if (type === 'no_profile_assigned') {
    return (
      <>
        <div className={'flex flex-col items-center justify-center py-16 px-4'}>
          <div className={'w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4'}>
            <ProfilIcon wh={32} color={'#9CA3AF'} />
          </div>
          <div className={'text-gray-900 font-semibold text-lg mb-2'}>{title[type]}</div>
          <div className={'text-gray-500 text-sm text-center max-w-md'}>
            {description[type]}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className={'max-w-[535px] my-16 mx-auto text-center px-3'}>
        <div className={'flex'}>{logo[type]}</div>
        <div className={'font-medium ft-xl text-[#5C616D]'}>{title[type]}</div>
        <div className={'font-normal ft-b mt-2 text-[#757575]'}>
          {description[type]}
        </div>
        <div className={'flex'}>
          <div className={'mx-auto'}>{button[type]}</div>
        </div>
      </div>
    </>
  );
};
export default EmptyState;
